



























import Vue from 'vue';
import { editTypeIndexDialog } from './EditEntityIndex';


export default Vue.extend({
  data: () => editTypeIndexDialog,
  computed: {
    isFullscreen(): boolean {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    title(): string {
      return this.name ? 'Edit Index' : 'Add Index';
    },
    invalidName(): boolean {
      if (!this.index.name) {
        return true;
      }
      if (!this.entity) {
        return false;
      }
      const existing = this.entity.indexes[this.index.name];
      if (existing && existing !== this.index) {
        return true;
      }
      const primary = this.entity.getPrimary();
      if (primary && primary !== this.index && primary.name === this.index.name) {
        return true;
      }
      return false;
    },
    disableSave(): boolean {
      return this.invalidName || this.index.props.length === 0;
    },
    isSaved(): boolean {
      return this.entity.indexes[this.index.name] === this.index;
    },
    buttonText(): string {
      return this.isSaved ? this.confirm : this.unconfirm;
    },
  },
});
